// extracted by mini-css-extract-plugin
export default {"projectsList":"projectsList_projectsList__fmBzX"};